import { ReactNode } from 'react';

interface DesktopContainerProps {
  children: ReactNode;
  className?: string;
}

export function DesktopContainer({ children, className = '' }: DesktopContainerProps) {
  return (
    <div className={`
      max-w-[1200px] 
      mx-auto 
      px-6
      lg:px-6
      xl:px-12
      2xl:px-[72px]
      min-[1920px]:px-24
      ${className}
    `}>
      {children}
    </div>
  );
}